/**
 * How many product tiles make up the first screenful of the collection grid.
 *
 * Derived from the grid itself: `.products .grid` is `repeat(16, 1fr)` and tiles span
 * `column-sm-4`, so desktop is 16/4 = 4 per row; mobile tiles are `column-xs-6` on a 12 column
 * grid, so 2 per row. Four tiles is therefore exactly one desktop row and two mobile rows.
 *
 * Two things key off this and have to stay in step, which is why it lives in its own module
 * rather than in either of them:
 *   - filteredCollection.js splits the first render here, so the above-fold tiles paint and
 *     start fetching before the rest of the page's tiles are built
 *   - productTileTemplateNosto.js marks images up to this index `loading="eager"`, everything
 *     after it `lazy`
 *
 * If the grid's columns change again, change this with them.
 */
const ABOVE_FOLD_TILES = 4;

/**
 * What `sizes` a collection grid tile's image should declare.
 *
 * The grid is full-bleed (`main[data-full-width="true"]`), so a tile is a fraction of the
 * viewport rather than a fixed width: 4 up above $sm and 2 up below it. Padding and the 20px
 * column gap make the real widths 25vw - 27px and 50vw - 3px, so these round values
 * over-declare very slightly, which is the safe direction.
 *
 * Written as a media query rather than a bare value per breakpoint because the markup is
 * generated once, at whatever breakpoint was current then, and is not re-rendered on resize.
 *
 * Note this is NOT right for slider tiles — those are sized by their carousel.
 */
const TILE_SIZES = '(min-width: 768px) 25vw, 50vw';

export {
  ABOVE_FOLD_TILES,
  TILE_SIZES,
};
